import Layout from '@/layout/TheLayout.vue'
import { EXTRANET_GROUPS } from './utils'

export default [
  {
    path: '/',
    name: 'Purchase',
    meta: {
      title: 'Compras',
      showInSidebar: true,
      icon: 'mdi-cart',
      excludeGroup: [...EXTRANET_GROUPS, 'Proveedor']
    },
    component: Layout,
    children: [
      {
        path: '/seguimiento_ordenes_de_compra/',
        name: 'Purchase Orders',
        component: () => import('@/pages/Purchase/PurchaseOrders/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Ordenes de compra'
        }
      },
      {
        path: '/seguimiento_requisiciones/',
        name: 'Requisitions',
        component: () => import('@/pages/Purchase/Requisitions/index'),
        meta: {
          showInSidebar: true,
          title: 'Requisiones'
        }
      }
    ]
  }
]
